import styled from 'styled-components';
import { IoIosCloseCircleOutline } from 'react-icons/io';

interface ItemProps {
  readonly dropZone?: boolean;
}

export const AdminHeader = styled.div`
  justify-content: space-between;
  padding-top: 40px;
  display: flex;

  @media (max-width: 570px) {
    white-space: nowrap;
    margin-right: 10px;
    overflow-x: auto;

    & > div {
      margin-left: 10px;
    }

    & > button {
      margin: 0 20px;
    }
  }
`;

export const AdminContent = styled.div`
  background-color: var(--BackgroundGrey);
  padding-top: 10px;
  padding-bottom: 20px;
  height: 70vh;
`;

export const RadiosContainer = styled.div`
  justify-content: flex-start;
  display: flex;
`;

export const RadiosContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AdHeader = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AdBody = styled.div`
  margin: 0 30px 30px 30px;
  min-width: 900px;
  @media (max-width: 950px) {
    min-width: 0px;
    width: 365px;
    overflow-x: auto;
  }
`;

export const AdBodyTitle = styled.span`
  display: inline-block;
  margin-bottom: 5px;
  line-height: 26px;
  font-weight: 500;
  font-size: 17px;
`;

export const AdFooter = styled.div`
  border-top: 1px solid var(--LightGray);
  justify-content: flex-end;
  padding: 30px 30px;
  margin-top: 20px;
  min-width: 292px;
  display: flex;
`;

export const AdBodyForm = styled.form`
  background-color: var(--BackgroundGrey);
  border: 1px solid #dce0e4;
  margin-bottom: 22px;
  border-radius: 8px;
`;

export const AdBodyFormUp = styled.div`
  justify-content: flex-start;
  padding: 0px 40px 5px 30px;
  display: flex;
`;

export const AdBodyBulk = styled.div<ItemProps>`
  ${props =>
    !props.dropZone
      ? `
  background-color: var(--BackgroundGrey);
  border: 1px solid #dce0e4;
  border-radius: 8px;`
      : `
  background-color: var(--BackgroundGrey);
  border: 2px dashed #dce0e4;
  border-radius: 8px;`}
`;

export const AdBodyBulkAdvise = styled.div`
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 80px 0;
  display: flex;
`;

export const AdBodyBulkCenter = styled.span`
  color: var(--DarkGray);
  font-size: 21px;
`;

export const AdBulkHeader = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

export const AdBulkBody = styled.div`
  margin-top: 5px;
`;

export const AdBulkHeaderTitle = styled.span`
  color: var(--DarkGray);
  font-size: 16px;
`;

export const AdBulkFooter = styled.div`
  justify-content: flex-end;
  margin-bottom: 30px;
  margin-right: 30px;
  display: flex;
`;

export const AdBodyFormHeader = styled.div`
  justify-content: flex-end;
  padding: 5px 5px 0 0;
  display: flex;
`;

export const AdBodyFormIcon = styled(IoIosCloseCircleOutline)`
  color: #787070;
  cursor: pointer;
  font-size: 20px;
  opacity: 100%;
`;
